
import { prokeyApi } from 'api/prokey';

//#region [Main] Constants

export const constants = {
  SET: 'THEME_SET'
}

//#endregion

//#region [Main] Actions

export const actions = {
  setTheme
};

function setTheme(theme) {
  return { type: constants.SET, payload: theme };
}

//#endregion

//#region [Main] Reducers

const initialState = 'theme-light';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET: {
      return action.payload;
    }
    default:
      return state
  }
}

//#endregion